import { render } from "./EditDiaryNote.vue?vue&type=template&id=96001446&scoped=true"
import script from "./EditDiaryNote.vue?vue&type=script&lang=js"
export * from "./EditDiaryNote.vue?vue&type=script&lang=js"

import "./EditDiaryNote.vue?vue&type=style&index=0&id=96001446&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96001446"]])

export default __exports__